import React, { Component } from 'react';
import './View.css';
import Home from './Home/Home.js'
import Portfolio from './Portfolio/Portfolio.js'
import Press from './Press/Press.js'
import Contact from './Contact/Contact.js'
import Navbar from './Navbar/Navbar.js'
import Focus from './Focus/Focus.js'
import Index from './Index/Index.js'

class View extends Component {

  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);
    this.changeProject = this.changeProject.bind(this);
    this.focusOnImage = this.focusOnImage.bind(this);
    this.removeFocus = this.removeFocus.bind(this);

    // switch page based on path in future - won't work at the moment
    // var pathname = window.location.pathname;
    // console.log(pathname);

    this.state = {
      page: "home",
      project: "rebirth",
      focus: false,
      focusData: {}
    }
  }

  componentDidUpdate() {
    if (this.state.page === "about") {
      document.getElementById("about-header").scrollIntoView();
    }
    else if (this.state.page === "home-portfolio") {
      document.getElementById("portfolio-header").scrollIntoView();
    }
  }

  changePage(e, targetPage) {
    e.preventDefault();

    this.setState({page: targetPage.toLowerCase()});
  }

  changeProject(e, targetProject) {
    e.preventDefault();
    this.setState({project: targetProject.toLowerCase()});
  }

  focusOnImage(e, data) {
    this.setState({focus: true, focusData: data})
  }

  removeFocus(e) {
    //don't unfocus if they click on the image
    if (e.target.className === "Focus-image") return

    this.setState({focus: false})
  }

  render() {
    // select the component corresponding to the selected page

    var page = {
      home: (<Home changePage={this.changePage} changeProject={this.changeProject} />),
      about: (<Home changePage={this.changePage} changeProject={this.changeProject} />),
      press: (<Press />),
      contact: (<Contact />),
      portfolio: (<Portfolio project={this.state.project} focusOnImage={this.focusOnImage} changeProject={this.changeProject} />),
      'home-portfolio': (<Home changePage={this.changePage} changeProject={this.changeProject} />)
    }[this.state.page]

    var focus = ""
    if (this.state.focus) {
      focus = (
        <Focus image={this.state.focusData.image}
               info={this.state.focusData.info}
               removeFocus={this.removeFocus} />
        )
    }

    return (
      <div className="View">
        {focus}
        <Navbar changePage={this.changePage} />
        {page}
        <Index changePage={this.changePage} changeProject={this.changeProject} />
      </div>
    );
  }
}

export default View;
